module.exports = __webpack_public_path__ + "static/back_ground_image_final-554d538d896d104f56ec6513bc169a29.jpg";